import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    boxShadow: 'none',
    padding: theme.spacing(0, 2),
    backgroundColor: theme.palette.common.white,
    '& .MuiToolbar-gutters': {
      padding: 0,
    },
  },
  toolbar: {
    padding: 0,
  },
  divider: {
    display: 'block',
    backgroundColor: theme.palette.divider,
    width: theme.spacing(0.125),
    height: theme.spacing(3),
    marginRight: theme.spacing(4),
  },
  title: {
    width: 'max-content',
    padding: theme.spacing(0, 5, 0, 2),
  },
  logo: {
    fontSize: '1.5rem',
    color: theme.palette.primary.dark,
  },
}));

export default useStyles;
